var STATUS_MESSAGE_EXIT_ANIMATION = 300;
var STATUS_MESSAGE_EXIT_DELAY = 5000;
var USER_INPUT_DELAY = 800;
export function FeaturePanel(container, options) {
  var userInputTimeout = null;
  var statusMessageTimeout = null;

  function statusElement() {
    return $(container).parents('.panel-collapse').prev('.panel-heading').find('.panel-status');
  }

  function errorElement() {
    return $(container).find('.alert.alert-danger-light');
  }

  function resetStatusMessageElements() {
    statusElement().show().removeClass('panel-status-error').removeClass('panel-status-success').addClass('panel-status-pending').text(I18n.t('javascript.saving_in_progress'));
    errorElement().addClass('hidden');
  }

  function updateStatusOnSuccess() {
    var $status = statusElement();
    $status.addClass('panel-status-success').text(I18n.t('javascript.changes_saved'));
    statusMessageTimeout = setTimeout(function () {
      $status.fadeOut(STATUS_MESSAGE_EXIT_ANIMATION, function () {
        $status.removeClass('panel-status-success');
      });
    }, STATUS_MESSAGE_EXIT_DELAY);
  }

  function showStatusError() {
    statusElement().addClass('panel-status-error').text(I18n.t('javascript.changes_not_saved'));
  }

  function showValidationError(error_message) {
    showStatusError();
    errorElement().removeClass('hidden').html(error_message);
  }

  function update(data, onBefore, onDone) {
    if (typeof onBefore === 'function') {
      onBefore();
    }

    clearTimeout(userInputTimeout);
    clearTimeout(statusMessageTimeout);
    userInputTimeout = setTimeout(function () {
      $.ajax({
        type: 'PUT',
        url: $(container).data('url'),
        dataType: 'json',
        contentType: 'application/json',
        data: JSON.stringify(data),
        beforeSend: resetStatusMessageElements
      }).done(function (response) {
        if (response.error && response.errors) {
          showValidationError(options.errorMessageTemplate(response.message, response.errors));
        } else if (response.error) {
          showValidationError(response.message);
        } else {
          updateStatusOnSuccess();

          if (typeof onDone === 'function') {
            onDone();
          }
        }
      }).fail(showStatusError).always(function () {
        statusElement().removeClass('panel-status-pending');
      });
    }, USER_INPUT_DELAY);
  }

  return {
    update: update
  };
}